module.exports = __webpack_public_path__ + "img/morestart.01c85c68.png";